import React, { useState, useEffect } from "react";

function Home({ setShowPackages }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    landingPage: {
      flex: 1,
      minHeight: isMobile ? "auto" : "calc(100vh - 42px)",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "linear-gradient(135deg, rgba(88, 101, 242, 0.1) 0%, rgba(10, 11, 14, 0.9) 100%)",
      position: "relative",
      overflow: "hidden",
      padding: isMobile ? "2rem 0" : 0,
    },
    landingContent: {
      position: "relative",
      zIndex: 1,
      textAlign: "center",
      animation: "fadeIn 1s ease-out",
      padding: isMobile ? "1rem" : "0 2rem",
      marginTop: isMobile ? 0 : "-10vh",
    },
    title: {
      fontSize: isMobile ? "2.5rem" : "5rem",
      marginBottom: "2rem",
      color: "#ffffff",
      textShadow: "0 0 20px rgba(88, 101, 242, 0.5)",
      letterSpacing: "4px",
      textTransform: "uppercase",
      background: "linear-gradient(45deg, #fff, #5865f2)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    aboutUs: {
      maxWidth: "800px",
      margin: isMobile ? "0 auto 2rem auto" : "0 auto 3rem auto",
      padding: isMobile ? "1rem" : "2rem",
      background: "rgba(88, 101, 242, 0.1)",
      border: "1px solid rgba(88, 101, 242, 0.2)",
      borderRadius: "16px",
      backdropFilter: "blur(8px)",
    },
    aboutUsText: {
      color: "#ffffff",
      fontSize: isMobile ? "1rem" : "1.2rem",
      lineHeight: isMobile ? 1.6 : 1.8,
      textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    },
    enterButton: {
      padding: "1rem 2.5rem",
      fontSize: "1.2rem",
      background: "rgba(88, 101, 242, 0.1)",
      border: "1px solid rgba(88, 101, 242, 0.5)",
      borderRadius: "8px",
      color: "#ffffff",
      cursor: "pointer",
      transition: "all 0.3s ease",
      position: "relative",
      overflow: "hidden",
      fontFamily: '"Space Grotesk", sans-serif',
      textTransform: "uppercase",
      letterSpacing: "2px",
      "&:hover": {
        background: "rgba(88, 101, 242, 0.2)",
        transform: "translateY(-5px)",
        boxShadow: "0 8px 32px rgba(88, 101, 242, 0.3)",
      },
    },
    beforePseudo: {
      content: '""',
      position: "absolute",
      top: "-50%",
      left: "-50%",
      width: "200%",
      height: "200%",
      background: "radial-gradient(circle at center, rgba(88, 101, 242, 0.1) 0%, rgba(45, 49, 77, 0.1) 25%, rgba(10, 11, 14, 0.2) 50%)",
      animation: "rotate 60s linear infinite",
      zIndex: 0,
    },
    footer: {
      width: "100%",
      textAlign: "center",
      padding: "1rem",
      color: "#8e9aff",
    },
  };

  return (
    <div>
      <div style={styles.landingPage}>
        <div style={{ ...styles.beforePseudo }} />
        <div style={styles.landingContent}>
          <h1 style={styles.title}>About Us</h1>
          <div style={styles.aboutUs}>
            <p style={styles.aboutUsText}>At BROT Auto Detailing, we specialize in transforming vehicles with precise attention to detail and professional-grade equipment, right at the convenience of your doorstep. No more need to drive to a shop or wait in long lines, simply schedule your appointment working around your schedule, and let us come to you. Our passion lies in reliability, exceptional work, customer service, and delivering top-tier results every time. Let us show you why we're the Bay Area's trusted choice for automotive care.</p>
          </div>
          <button style={styles.enterButton} onClick={() => setShowPackages("packages")}>
            View Our Services
          </button>
        </div>
      </div>
      {!isMobile && (
        <>
          <div className="contact-section">
            <h2>Text or Email Us!</h2>
            <div className="contact-info">
              <a href="tel:+16504544583" className="contact-item">
                <span className="icon">📞</span>
                (650) 454-4583
              </a>
              <a href="mailto:brotdetailing@gmail.com" className="contact-item">
                <span className="icon">📧</span>
                brotdetailing@gmail.com
              </a>
            </div>
          </div>
          <p style={styles.footer}>&copy; 2025 BROT Auto Detailing</p>
        </>
      )}
    </div>
  );
}

export default Home;
